export default __webpack_public_path__ + "static/media/art-card-bg.b60d99d3.svg";